import { render, staticRenderFns } from "./TeamLeaderDashboard.vue?vue&type=template&id=36b644dc&"
import script from "./TeamLeaderDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeamLeaderDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports